module.exports = __webpack_public_path__ + "media/images/obs-7c8619554ae6ee4e645ea97238a2efed.png";